export const generateRandomNumber = (): number => {
    return Date.now() + Math.floor(Math.random() * 1000);
};